var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Quality"}},[_c('TopNav'),_c('div',{staticClass:"pageCon"},[_c('LeftNav'),_c('div',{staticClass:"page"},[_c('Breadcrumb'),_c(_vm.comName,{tag:"component",attrs:{"comName":_vm.comName},on:{"update:comName":function($event){_vm.comName=$event},"update:com-name":function($event){_vm.comName=$event}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }